<template>
  <div class="PastRecommendationsPreSignIn">
    <Retailnavbar style="position: fixed;
                    top: 0;
                    width: 100%; z-index: 5;"></Retailnavbar>

    <ChatBannerComponent class="banner-mobile"></ChatBannerComponent>

    <div class="pastRecoContainer">
      <div class="desktopFilterSection">
        <FilterForDesktopView :filter_title="filter_title"></FilterForDesktopView>
      </div>

      <div class="recoListSection">
        <div class='stock-data-section'
          :class="websiteUserType.userSubType != 'brokerWithoutPlans' ? 'stock-data-section' : 'stock-data-section-second'">

          <ChatBannerComponent class="banner-desktop"></ChatBannerComponent>

          <StrategyCard :recommendationsList="past_reco_track_list"></StrategyCard>
        </div>

        <div v-if="!is_list_loading && !past_reco_track_list.length">
          <NoDataFound></NoDataFound>
        </div>

        <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_list_loading">
          <div class="text-center">
            <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import MobileNav from "@/components/MobileNav.vue";
import SearchStock from "@/components/SearchStock.vue";
import RecoActionButtons from "@/components/RecoActionButtons.vue";
import MobileFilterDialog from "@/components/MobileFilterDialog.vue";
import FilterForDesktopView from "@/components/FilterForDesktopViewDerivatives.vue";
import ChatBannerComponent from "@/components/ChatBannerComponent.vue";
import NoDataFound from "@/components/NoDataFound.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { filterCallBack } from "../mixins/filter";
import { EventBus } from "../eventBus";
import StrategyCard from "@/components/StrategyCardPreSignUp.vue";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import CripNotice from "crip-vue-notice";
import Retailnavbar from "@/components/RetailSideCompo/RetailNavbar.vue";

export default {
  name: "PastStrategies",

  mixins: [HelperNetworkCallBack, filterCallBack, screenSize],

  components: {
    MobileNav,
    "search-stock": SearchStock,
    NoDataFound,
    RecoActionButtons,
    FilterForDesktopView,
    StrategyCard,
    StockFilter: MobileFilterDialog,
    Retailnavbar,
    ChatBannerComponent
  },

  data() {
    return {
      segment: "Options",
      nav_title: "Past Strategy",
      filter_title: "Past Strategy",
      is_list_loading: false,
      past_reco_track_list: [],
      stock_list: "",
      is_scroll_disabled: true,
      page_no: 1,
      number_of_pages: null,
      stock_code: "",
      stock_widget_visible: false,
      kite: "",
      update_recommendation_dialog_visible: false,
      selected_reco_to_update: {},
      selected_reco_index: "",
      short_term_target_period_list: [],
      long_term_target_period_list: [],
      reco_loading: false,
      reco_price_market: "",
      websiteUserType: localStorage.getItem("websiteUserType")
        ? JSON.parse(localStorage.getItem("websiteUserType"))
        : {},
    };
  },

  //

  mounted() {
    //get all short term reco data track
    this.getAllPastRecoList(this.filter_obj);
  },

  methods: {

    getAllPastRecoList(filter_obj) {
      this.is_list_loading = true;

      serverAddr
        .post("/options/open_api/opinion/market", {
          page_no: 1,
          page_per_entries: 2,
        })
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;
            // this.is_scroll_disabled = true;   //enable scroll for more stock
            this.number_of_pages = response.data.pagination.total_pages;
            var end_date = new Date();

            response.data.data.forEach((element, index) => {
              // created new key toggle_more_info in response for toggle more info section
              this.$set(element, "toggle_more_info", false);
              this.$set(element, "expert_list", []);
              this.$set(element, "closed_reco_list", []);
              this.$set(element, "closed_reco_list_loading", false);
              this.$set(element, "is_loading", false);
              this.$set(element, "compared_experts_list", []);

              element.totalRemainingPotential = 0;

              element.totalRemainingPotential = 0;
              element.data.forEach((legValue) => {
                var currentPrice = null;
                if (legValue.status == "EXIT") {
                  currentPrice = legValue.status_action_price;
                } else if (legValue.status == "TARGET_ACHIEVED") {
                  currentPrice = legValue.target_premium;
                } else if (legValue.status == "STOPLOSS_TRIGGERED") {
                  currentPrice = legValue.stop_loss;
                } else if (legValue.status == "YET_TO_LIVE") {
                  currentPrice = legValue.entry_premium;
                } else {
                  currentPrice = legValue.stock.ltp;
                }

                if (legValue.direction == "BUY") {
                  // legValue.remainingPotentialInRupees = (legValue.target_premium - currentPrice) * legValue.quantity * legValue.stock.lot_size
                  legValue.remainingPotentialInRupees =
                    (legValue.target_premium - currentPrice) *
                    10 *
                    legValue.stock.lot_size;
                } else if (legValue.direction == "SELL") {
                  // legValue.remainingPotentialInRupees = (currentPrice - legValue.target_premium) * legValue.quantity * legValue.stock.lot_size
                  legValue.remainingPotentialInRupees =
                    (currentPrice - legValue.target_premium) *
                    10 *
                    legValue.stock.lot_size;
                }
                element.totalRemainingPotential =
                  element.totalRemainingPotential +
                  legValue.remainingPotentialInRupees;

                legValue.lot_quantity = 1;
                // legValue.exp_tax =
                //   legValue.brokerage_data.total_tax_and_charges;
                legValue.brokerage_loader = false;
                legValue.strategy_id = element.strategy.id;
              });
              var titleExpiry = element.strategy.title.split(" ");
              element.strategy.title = titleExpiry[0];
              element.strategy.expiry = titleExpiry[1];

              element.strategy.difference_in_days = this.getDifferenceBetweenTwoDays(
                element.strategy.created_date,
                end_date
              );
              element.strategy.today = end_date;
              element.is_strategy_loading = false;
              element.toggle_more_info = false;

              if (element.logic[0]) {
                var mediaArray = [];
                if (element.logic[0].media_1) {
                  mediaArray.push(element.logic[0].media_1);
                }
                if (element.logic[0].media_2) {
                  mediaArray.push(element.logic[0].media_2);
                }
                if (element.logic[0].media_3) {
                  mediaArray.push(element.logic[0].media_3);
                }
                if (element.logic[0].media_4) {
                  mediaArray.push(element.logic[0].media_4);
                }

                element.logic[0].mediaArray = mediaArray;
              }
              this.past_reco_track_list.push(response.data.data[index]);
            });

            // this.scrollToTop();     //scroll to top of list
          } else {
            this.is_list_loading = false;
            // this.is_scroll_disabled = false;
            this.past_reco_track_list = [];
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_list_loading = false;
            // this.is_scroll_disabled = false;
          }.bind(this)
        );
    },
  },

  beforeDestroy() {
    EventBus.$off();
    // window.removeEventListener('scroll', this.loadMoreStocks());
    // this.is_scroll_disabled = false;
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.PastRecommendationsPreSignIn {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 0;


  .banner-mobile {
    display: none;
  }

  .stock-data-section {
    padding-top: 53px;
  }

}


.PastRecommendationsPreSignIn .search-stock-section {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: $page-background-color;
  padding: 15px 0px;
  width: 100%;
}

.PastRecommendationsPreSignIn .recoListSection {
  box-sizing: border-box;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 0 10px;
  min-height: 100vh;
}

.PastRecommendationsPreSignIn .footer-section {
  width: calc(100% - 285px);
  margin-left: 285px;
}

//media queries
@media screen and (max-width: 1283px) {
  .PastRecommendationsPreSignIn {
    padding: 50px 0 80px 0;
  }

  .PastRecommendationsPreSignIn .recoListSection {
    width: 100%;
    margin-left: 0;
  }

  .PastRecommendationsPreSignIn .footer-section {
    width: 100%;
    margin-left: 0;
  }


  .PastRecommendationsPreSignIn .stock-data-section {
    // padding: 30px 0 0;
    padding-top: 0;
  }

  .PastRecommendationsPreSignIn .action-btn-component {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }

  .desktopFilterSection {
    display: none;
  }
}


@media screen and (max-width: 1099px) {
  .PastRecommendationsPreSignIn {

    // .stock-data-section {
    //   padding: 90px 0 0 0;
    // }
    .stock-data-section-second {
      padding: 30px 0 0 0;
    }
  }
}

@media screen and (max-width: 727px) {
  .PastRecommendationsPreSignIn {

    .banner-mobile {
      display: block;
      margin-bottom: 15px;
    }

    .banner-desktop {
      display: none;
    }
  }

}

@media screen and (max-width: 500px) {
  .PastRecommendationsPreSignIn {
    // .stock-data-section {
    //   padding: 70px 0 0 0;
    // }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.PastRecommendationsPreSignIn .update-reco-card {
  box-shadow: none;
}

.PastRecommendationsPreSignIn .rupees-symbol {
  position: absolute;
  top: 7px;
  left: 15px;
  z-index: 1;
  font-size: 0.9rem;
  color: black;
  font-weight: bold;
}

.PastRecommendationsPreSignIn .percentSymbol {
  position: absolute;
  top: 5px;
  right: 80px;
  z-index: 1;
  color: #606266;
}

.PastRecommendationsPreSignIn .unlocked-antestimate-notifybar {
  cursor: pointer;
  color: black;
  font-weight: 800;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  display: flex;
  transition: opacity 0.2s;
  font-size: 1.2rem;
}

.PastRecommendationsPreSignIn .selection-tag {
  font-size: 0.7rem;
  height: 25px;
  line-height: 24px;
}

.PastRecommendationsPreSignIn .stock-details-section {
  display: flex;
  align-items: center;
}

.PastRecommendationsPreSignIn .stock-title {
  max-width: 300px;
}

.PastRecommendationsPreSignIn .current-price {
  font-size: 1.2rem;
  font-weight: 600;
  color: #000;
}

.PastRecommendationsPreSignIn .border-bottom-gray {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.PastRecommendationsPreSignIn .cross-icon {
  color: #ddd;
  font-size: 20px;
  cursor: pointer;
}

.PastRecommendationsPreSignIn .cross-icon:hover {
  font-size: 20px;
  color: #000;
}

.PastRecommendationsPreSignIn .el-select-dropdown__item {
  color: #000 !important;
  font-weight: 300 !important;
}

.PastRecommendationsPreSignIn .target-price-input {
  width: 100%;
}

.PastRecommendationsPreSignIn .sector-dropdown .el-input__inner {
  border-radius: 12px;
  height: 20px;
  border-radius: 10px;
  font-size: 0.6rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #000;
}

.PastRecommendationsPreSignIn .target-price-input-section .el-input__inner::placeholder {
  font-size: 0.8rem;
  font-weight: 500;
}

.PastRecommendationsPreSignIn .el-select .el-input .el-select__caret.is-reverse {
  position: absolute;
  top: -4px;
  right: 0;
}

.PastRecommendationsPreSignIn .sector-dropdown .el-select__caret {
  position: absolute;
  top: 3px;
  right: 0;
}

.PastRecommendationsPreSignIn .sector-dropdown .el-select__caret {
  font-size: 13px;
}

.PastRecommendationsPreSignIn .target-price-input .el-input__inner {
  border-radius: 25px;
}

.PastRecommendationsPreSignIn .target-price-input .el-input-number__increase,
.PastRecommendationsPreSignIn .target-price-input .el-input-number__decrease {
  line-height: 0;
  border-radius: 50px;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  border: none;
  background-color: $secondary-theme-color;
  border-color: $secondary-theme-color;
  color: #fff;
  display: none;
}

.PastRecommendationsPreSignIn .target-price-input .el-input-number__decrease {
  right: 35px;
  top: 5px;
}

.PastRecommendationsPreSignIn .target-price-input .el-input-number__increase {
  right: 5px;
  top: 5px;
}

.PastRecommendationsPreSignIn .target-price-input-section .el-input__inner {
  text-align: left;
  // height: 35px;
  padding-left: 30px;
  color: black;
  font-weight: 600;
  font-size: 0.9rem;
}

.PastRecommendationsPreSignIn .potential-return-value {
  font-size: 0.7rem;
  font-weight: 600;
  position: absolute;
  top: 8px;
  right: 8px;
  // right: 30%;
  z-index: 1;
  color: #979797;
}

.PastRecommendationsPreSignIn .inactive-period-type-tag {
  text-align: center;
  border-radius: 12px;
  padding: 0 10px;
  margin: 0 0.3rem 0 0;
  background-color: #fff;
  border-color: #d9d9d9;
  font-weight: 600;
  color: #878787;
  min-width: 50px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 10px;
}

.PastRecommendationsPreSignIn .disabled-period-type-tag {
  margin-right: 0.3rem;
  border-radius: 12px;
  padding: 0 10px;
  min-width: 50px;
  font-weight: 600;
  text-align: center;
  border-color: #ddd;
  background-color: #ddd;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
  cursor: not-allowed;
}

.PastRecommendationsPreSignIn .active-period-type {
  margin-right: 0.3rem;
  border-radius: 12px;
  padding: 0 10px;
  min-width: 50px;
  font-weight: 600;
  text-align: center;
  border-color: $secondary-theme-color;
  background-color: $secondary-theme-color;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
}

.PastRecommendationsPreSignIn .active-period-type:focus,
.PastRecommendationsPreSignIn .inactive-period-type-tag:focus {
  outline: none;
}

.PastRecommendationsPreSignIn .el-button.is-disabled.is-plain {
  border-radius: 61px;
}

.PastRecommendationsPreSignIn .el-button.is-disabled.is-plain {
  background-color: #eee;
}

.PastRecommendationsPreSignIn .info-Logo {
  height: 9px;
  padding: 0px 2px 0px 3px;
}

.PastRecommendationsPreSignIn .NoDataFound {
  padding: 60px 0 0 0;
}

.PastRecommendationsPreSignIn .quarter-tag {

  // width: 170px;
  input {
    border-radius: 25px;
    // height: 25px;
  }

  input::placeholder {
    // color: $primary-theme-color;
    // font-size: 10px;
    font-weight: 500;
  }
}

.PastRecommendationsPreSignIn .active-quarter {
  input {
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
    color: #fff;
  }

  .el-select__caret {
    color: #fff;
  }
}

.PastRecommendationsPreSignIn .upload-btn {
  background: #d5d3e0;
  color: #000;
  padding: 5px 15px;
  border-radius: 50px;
  font-size: 0.7rem;
  font-weight: 500;
  width: fit-content;
  cursor: pointer;
}

.reco-update-dialog {
  width: 60%;
}

.segment-radio-btn {
  display: flex;
  justify-content: end;
  margin-right: 10px;
  // .el-radio__input.is-disabled .el-radio__inner,
  // .el-radio__input.is-disabled.is-checked .el-radio__inner {
  //   background-color: #fb0010;
  //   border-color: #e72726;
  // }

  // .el-radio__input.is-disabled + span.el-radio__label {
  //   color: #606266;
  // }
  .custom-segment-btn {
    border: none;
    color: #3b3b3b;
  }
}

@media screen and (max-width: 650px) {
  .reco-update-dialog {
    width: 90%;
  }
}
</style>
